import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { noteSchema } from "@backend/src/schemas/taskSchema";


export interface TaskNote {
  noteId: string;
  note: string;
  taskId: string;
  createdByUserId: string;
  updatedByUserId?: string | null;
  createdAt: string;
  updatedAt?: string | null;
}


type AddNoteResponseType = ResponseType<TaskNote>;

function useAddNoteMutation(taskId: string) {
  const mutation = useMutation<
    AxiosResponseAndError<AddNoteResponseType>["response"],
    AxiosResponseAndError<AddNoteResponseType>["error"],
    z.infer<typeof noteSchema> & {tempId:string}
  >({
    mutationFn: async (data) => {
      return ApiRequest.post<AddNoteResponseType>(
        `${requestURLs.taskNote}${data.tempId ? data.tempId : taskId}`,
        data
      );
    },
  });

  return mutation;
}

export default useAddNoteMutation;
